module.exports = __webpack_public_path__ + "static/media/modern_board.d297f3fc.png";